import { assertNever } from "@redotech/util/type";

export enum SlideInPanelAnchorLocation {
  BOTTOM_LEFT = "BOTTOM_LEFT",
  BOTTOM_RIGHT = "BOTTOM_RIGHT",
  TOP_LEFT = "TOP_LEFT",
  TOP_RIGHT = "TOP_RIGHT",
}

export const SaveForLaterSlideInPanelAnchorLocation = [
  SlideInPanelAnchorLocation.BOTTOM_LEFT,
  SlideInPanelAnchorLocation.BOTTOM_RIGHT,
] as const;
export type SaveForLaterSlideInPanelAnchorLocation =
  (typeof SaveForLaterSlideInPanelAnchorLocation)[number];

export const getSlideInPanelAnchorLocationLabel = (
  anchorLocation: SlideInPanelAnchorLocation,
) => {
  switch (anchorLocation) {
    case SlideInPanelAnchorLocation.BOTTOM_LEFT:
      return "Bottom left";
    case SlideInPanelAnchorLocation.BOTTOM_RIGHT:
      return "Bottom right";
    case SlideInPanelAnchorLocation.TOP_LEFT:
      return "Top left";
    case SlideInPanelAnchorLocation.TOP_RIGHT:
      return "Top right";
    default:
      assertNever(anchorLocation);
  }
};

export const getSaveForLaterSlideInPanelAnchorLocation = (
  anchorLocation: SaveForLaterSlideInPanelAnchorLocation,
) => {
  switch (anchorLocation) {
    case SlideInPanelAnchorLocation.BOTTOM_LEFT:
      return getSlideInPanelAnchorLocationLabel(
        SlideInPanelAnchorLocation.BOTTOM_LEFT,
      );
    case SlideInPanelAnchorLocation.BOTTOM_RIGHT:
      return getSlideInPanelAnchorLocationLabel(
        SlideInPanelAnchorLocation.BOTTOM_RIGHT,
      );
    default:
      assertNever(anchorLocation);
  }
};

export const DEFAULT_SAVE_FOR_LATER_PANEL_ANCHOR_LOCATION: SaveForLaterSlideInPanelAnchorLocation =
  SlideInPanelAnchorLocation.BOTTOM_LEFT;
